<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <template v-else>
      <SectionHeader :title="$t('orders.headline')">
        <template v-slot:breadcrumbs>
          <BreadCrumbs
            :items="[
              { text: $t('meta.orders'), name: 'orders' },
              { text: $t('meta.orderTemplates'), name: 'order_templates' },
              {
                text: orderTemplate.name,
                name: 'show_order_template',
                params: { orderTemplateUuid: orderTemplate.uuid },
              },
            ]"
          />
        </template>
      </SectionHeader>

      <div id="order-template-form">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('orderTemplates.edit') }}</h3>
          </header>

          <div class="content-body">
            <OrderTemplateForm
              :existingOrderTemplate="orderTemplate"
              @submit="updateOrderTemplate"
              :companyUuid="companyUser.company_uuid"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import OrderTemplateForm from '@/views/order_templates/form'

import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader/index.vue'

import orderTemplatesApi from '@/api/orderTemplates'

export default {
  name: 'show_order_template',
  components: { BreadCrumbs, SectionHeader, LoadingSpinner, OrderTemplateForm },
  inject: ['companyUser'],
  data: () => ({
    loading: true,
    orderTemplate: {},
  }),
  methods: {
    updateOrderTemplate: async function (orderTemplate) {
      const updatedOrderTemplate = await orderTemplatesApi.update(orderTemplate.uuid, {
        name: orderTemplate.name,
        order_type: orderTemplate.order_type,
        site_uuid: orderTemplate.site_uuid,
        weekdays: orderTemplate.weekdays,
        vehicle_uuid: orderTemplate.vehicle_uuid,
        paused: orderTemplate.paused,
        continue_on: orderTemplate.paused ? orderTemplate.continue_on : null,
      })

      if (updatedOrderTemplate.success) {
        await this.$router.push('/order_templates')
      }
    },
  },
  async mounted() {
    this.orderTemplate = await orderTemplatesApi.get(this.$route.params.orderTemplateUuid)
    this.orderTemplate.site_uuid = this.orderTemplate.site.uuid
    this.orderTemplate.vehicle_uuid = this.orderTemplate.vehicle.uuid

    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
#order-template-form {
  padding: 1.25rem;
}
</style>
